import { render, staticRenderFns } from "./MediaControls.vue?vue&type=template&id=3ce6ba71"
import script from "./MediaControls.vue?vue&type=script&lang=ts"
export * from "./MediaControls.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports